import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import _ from 'lodash';
import { Table, Icon, Popup } from 'semantic-ui-react';
import TokenStatusModal from '../../containers/token-status-modal';

const commaFormat = num => numeral(num).format('0a');
const SHORTLIST_MODE = 'SHORTLIST';

const iconStyle = {
  height: '24px',
  width: '24px',
};


const StatusIconAuthorised = ({ channel, handle, mode }) => (
  <Popup
    trigger={<Icon name="check circle outline" color="green" size="large" />}
    content={`${_.upperFirst(channel)} channel ${handle} has been authorised.`}
  />
);

const StatusIconWarn = ({ channel, handle, influencer }) => {
  //
  if (channel === 'instagram') {
    return <TokenStatusModal handle={handle} channel={channel} influencer={influencer} />;
  }

  return (
    <Popup
      trigger={<Icon name="warning circle" color="orange" size="large" />}
      content={`Something went wrong accessing data from ${_.upperFirst(channel)} channel ${handle}`}
    />
  );
};

const StatusIconNotAuthorised = ({ channel, handle }) => (
  <Popup
    trigger={<Icon name="lock" color="grey" size="large" />}
    content={`${_.upperFirst(channel)} channel ${handle} has NOT been authorised.`}
  />
);

const getYoutubeLink = influencer => {
  const { youtube } = influencer;
  if (!youtube) return '';
  const channelIdRegex = /^UC([a-zA-Z0-9_-]{22})$/;
  return youtube.match(channelIdRegex) ? 'channel/' : 'user/';
};


export const getAuthorisedIcon = (influencer, channel) => {
  const handle = influencer[channel];
  const isAuthorised = influencer[`${channel}Authorised`];
  const isTokenValid = influencer[`${channel}Status`] === 'AUTHORIZED';

  if (!isAuthorised) {
    return <StatusIconNotAuthorised channel={channel} handle={handle} />;
  }

  if (isAuthorised && isTokenValid) {
    return <StatusIconAuthorised channel={channel} handle={handle} />;
  }

  if (isAuthorised && !isTokenValid) {
    return <StatusIconWarn channel={channel} handle={handle} influencer={influencer} />;
  }

  return null;
};

const getLinkedItem = (influencer, channel, mode) => {
  const handle = influencer[channel];
  const youtubeShim = channel === 'youtube' ? getYoutubeLink(influencer) : '';

  const isShortlistMode = mode === SHORTLIST_MODE;

  const tiktokExtra = channel === 'tiktok' ? '@' : '';

  if (handle) {
    return (
      <a
        href={`https://www.${channel}.com/${youtubeShim}${tiktokExtra}${handle}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img style={iconStyle} src={`/icons/${channel}.svg`} alt={channel} />
        {!isShortlistMode && getAuthorisedIcon(influencer, channel)}
        <p className="light">{commaFormat(influencer[`${channel}Count`])}</p>
      </a>
    );
  }

  return (
    <div>
      <img style={iconStyle} src={`/icons/${channel}.svg`} alt={channel} />
      <p className="light">{commaFormat(0)}</p>
    </div>
  );
};

const SocialTable = ({ influencer, mode }) => (
  <Table fixed textAlign="center" basic="very">
    <Table.Body>
      <Table.Row>
        <Table.Cell>
          { getLinkedItem(influencer, 'instagram', mode) }
        </Table.Cell>
        <Table.Cell>
          { getLinkedItem(influencer, 'facebook', mode) }
        </Table.Cell>
        <Table.Cell>
          { getLinkedItem(influencer, 'youtube', mode) }
        </Table.Cell>
        <Table.Cell>
          { getLinkedItem(influencer, 'tiktok', mode) }
        </Table.Cell>
        <Table.Cell>
          { getLinkedItem(influencer, 'twitch', mode) }
        </Table.Cell>
        <Table.Cell>
          { getLinkedItem(influencer, 'twitter', mode) }
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table>
);

SocialTable.propTypes = {
  influencer: PropTypes.object.isRequired,
};

export default SocialTable;



/** WEBPACK FOOTER **
 ** ./src/components/social-table/index.js
 **/